import {Reducer} from 'react';
import {AccordionItemType} from './Accordion';

export type State = Record<string, {expanded: boolean; isAnimating: boolean}>;

type Action =
  | {type: 'SET_ANIMATION'; itemId: string}
  | {type: 'TOGGLE'; itemId: string};

export const createInitialState = ({
  items,
  initialExpandedItem,
}: {
  items: AccordionItemType[];
  initialExpandedItem?: AccordionItemType['id'];
}) =>
  items.reduce<State>((state, item) => {
    state[item.id] = {
      expanded: initialExpandedItem === item.id,
      isAnimating: false,
    };

    return state;
  }, {});

export const reducer: Reducer<State, Action> = (state, action) => {
  switch (action.type) {
    case 'TOGGLE':
      return Object.fromEntries(
        Object.entries(state).map(([key, state]) => [
          key,
          {
            ...state,
            expanded: key === action.itemId ? !state.expanded : false,
            isAnimating: key === action.itemId ? true : state.expanded,
          },
        ])
      );

    case 'SET_ANIMATION':
      return {
        ...state,
        [action.itemId]: {
          ...state[action.itemId],
          isAnimating: false,
        },
      };

    default:
      return state;
  }
};
